import { cn } from '@/lib/utils/cn';
import type { InspectedTarget } from './types';

/** Drawn over the page, so the inspected element itself is never touched. */
export function InspectorHighlight({ target }: { target: InspectedTarget }) {
  const { rect, keys } = target;
  const [first, ...rest] = keys;
  // Grows away from the nearer edge, so a label near the right stays on screen.
  const alignRight = rect.left + rect.width / 2 > window.innerWidth / 2;

  return (
    <div
      aria-hidden
      className='pointer-events-none fixed z-[60] rounded-sm outline-2 outline-primary outline-offset-1 bg-primary/5'
      style={{
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height,
      }}
    >
      <span
        data-testid='translation-inspector-label'
        className={cn(
          'absolute bottom-full mb-1 whitespace-nowrap rounded-sm bg-primary px-1.5 py-0.5 font-mono text-[10px] text-primary-foreground',
          alignRight ? 'right-0' : 'left-0',
        )}
      >
        {first}
        {rest.length > 0 && ` +${rest.length}`}
      </span>
    </div>
  );
}
